module.exports = "<div class=\"wrapper\">\n    <div class=\"outer-panel\">\n        <router-outlet></router-outlet>\n        <app-footer></app-footer>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/ext-layout/ext-layout.component.html
// module id = ./src/app/layouts/ext-layout/ext-layout.component.html
// module chunks = main